
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artigos/[uid]",
      function () {
        return require("private-next-pages/artigos/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artigos/[uid]"])
      });
    }
  